module.exports = __webpack_public_path__ + "static/media/rocket.a2a35624.gif";